module.exports = __webpack_public_path__ + "img/close-s.9bf2e193.svg";